import axios from 'axios';
import {
  CONSOLE_LIST_REQUEST,
  CONSOLE_LIST_SUCCESS,
  CONSOLE_LIST_FAIL,
  CONSOLE_DETAILS_REQUEST,
  CONSOLE_DETAILS_SUCCESS,
  CONSOLE_DETAILS_FAIL,
  CONSOLE_CREATE_REQUEST,
  CONSOLE_CREATE_SUCCESS,
  CONSOLE_CREATE_FAIL,
  CONSOLE_CREATE_ACKNOWLEDGE,
  CONSOLE_DELETE_REQUEST,
  CONSOLE_DELETE_SUCCESS,
  CONSOLE_DELETE_FAIL,
  CONSOLE_ITEM_LIST_REQUEST,
  CONSOLE_ITEM_LIST_SUCCESS,
  CONSOLE_ITEM_LIST_FAIL,
  CONSOLE_ITEM_DETAILS_REQUEST,
  CONSOLE_ITEM_DETAILS_SUCCESS,
  CONSOLE_ITEM_DETAILS_FAIL,
  CONSOLE_ITEM_CREATE_REQUEST,
  CONSOLE_ITEM_CREATE_SUCCESS,
  CONSOLE_ITEM_CREATE_FAIL,
  CONSOLE_ITEM_CREATE_ACKNOWLEDGE,
  CONSOLE_ITEM_UPDATE_REQUEST,
  CONSOLE_ITEM_UPDATE_SUCCESS,
  CONSOLE_ITEM_UPDATE_FAIL,
  CONSOLE_ITEM_UPDATE_ACKNOWLEDGE,
  CONSOLE_ITEM_DELETE_REQUEST,
  CONSOLE_ITEM_DELETE_SUCCESS,
  CONSOLE_ITEM_DELETE_FAIL,
  LIST_ITEM_ADD_REQUEST,
  LIST_ITEM_ADD_SUCCESS,
  LIST_ITEM_ADD_FAIL,
  LIST_ITEM_UPDATE_REQUEST,
  LIST_ITEM_UPDATE_SUCCESS,
  LIST_ITEM_UPDATE_FAIL,
  LIST_ITEM_DELETE_REQUEST,
  LIST_ITEM_DELETE_SUCCESS,
  LIST_ITEM_DELETE_FAIL,
} from '../constants/consoleConstants';

// List user consoles
export const listUserConsoles = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CONSOLE_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get('/api/consoles/user', config);

    dispatch({
      type: CONSOLE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CONSOLE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get console details
export const getConsoleDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CONSOLE_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`/api/consoles/${id}`, config);

    dispatch({
      type: CONSOLE_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CONSOLE_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Create console
export const createConsole = (title, ownerId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CONSOLE_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      '/api/consoles',
      { title, ownerId },
      config
    );

    dispatch({
      type: CONSOLE_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CONSOLE_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Acknowledge console creation
export const acknowledgeConsoleCreation = () => (dispatch) => {
  dispatch({ type: CONSOLE_CREATE_ACKNOWLEDGE });
};

// Delete console
export const deleteConsole = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CONSOLE_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`/api/consoles/${id}`, config);

    dispatch({
      type: CONSOLE_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: CONSOLE_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// List console items. `background: true` fetches silently — no spinner, and a failure leaves the
// current items alone.
export const listConsoleItems = (consoleId, { background = false } = {}) => async (dispatch, getState) => {
  try {
    if (!background) dispatch({ type: CONSOLE_ITEM_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`/api/console-items/console/${consoleId}`, config);

    dispatch({
      type: CONSOLE_ITEM_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (background) return;
    dispatch({
      type: CONSOLE_ITEM_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get console item details
export const getConsoleItemDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CONSOLE_ITEM_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`/api/console-items/${id}`, config);

    dispatch({
      type: CONSOLE_ITEM_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CONSOLE_ITEM_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Create console item. `item` is { displayName, itemType, consoleId } plus that type's field
// (see client/src/components/Console/itemTypes)
export const createConsoleItem = (item) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: CONSOLE_ITEM_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post('/api/console-items', item, config);

    dispatch({
      type: CONSOLE_ITEM_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CONSOLE_ITEM_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Acknowledge console item creation
export const acknowledgeConsoleItemCreation = () => (dispatch) => {
  dispatch({ type: CONSOLE_ITEM_CREATE_ACKNOWLEDGE });
};

// Update console item. `changes` is { displayName, itemType } plus that type's field
export const updateConsoleItem = (id, changes) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: CONSOLE_ITEM_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`/api/console-items/${id}`, changes, config);

    dispatch({
      type: CONSOLE_ITEM_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CONSOLE_ITEM_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Acknowledge console item update
export const acknowledgeConsoleItemUpdate = () => (dispatch) => {
  dispatch({ type: CONSOLE_ITEM_UPDATE_ACKNOWLEDGE });
};

// Delete console item
export const deleteConsoleItem = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CONSOLE_ITEM_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`/api/console-items/${id}`, config);

    dispatch({
      type: CONSOLE_ITEM_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: CONSOLE_ITEM_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Add list item to console item
export const addListItem = (consoleItemId, title, description, image, link) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LIST_ITEM_ADD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const requestBody = {
      title,
      description,
    };

    // Only include image if provided
    if (image) {
      requestBody.image = image;
    }

    // Only include link if provided
    if (link) {
      requestBody.link = link;
    }

    const { data } = await axios.post(
      `/api/console-items/${consoleItemId}/list-items`,
      requestBody,
      config
    );

    dispatch({
      type: LIST_ITEM_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LIST_ITEM_ADD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Update list item
export const updateListItem = (consoleItemId, listItemId, title, description, image, link) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LIST_ITEM_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const requestBody = {
      title,
      description,
    };

    // Only include image if provided (not undefined)
    if (image !== undefined) {
      requestBody.image = image;
    }

    // Only include link if provided (not undefined)  
    if (link !== undefined) {
      requestBody.link = link;
    }

    const { data } = await axios.put(
      `/api/console-items/${consoleItemId}/list-items/${listItemId}`,
      requestBody,
      config
    );

    dispatch({
      type: LIST_ITEM_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LIST_ITEM_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Delete list item
export const deleteListItem = (consoleItemId, listItemId) => async (dispatch, getState) => {
  try {
    dispatch({ type: LIST_ITEM_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`/api/console-items/${consoleItemId}/list-items/${listItemId}`, config);

    dispatch({
      type: LIST_ITEM_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: LIST_ITEM_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};